module.exports = __webpack_public_path__ + "img/wheel_in2.71d5dbeb.png";